module.exports = __webpack_public_path__ + "static/img/visiteNew.68addf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/visiteNew.jpg
// module id = pTth
// module chunks = 1